import { Stack, Button, Divider, Typography } from "@mui/material";
import { IconEyeLine } from "src/components/icons-mui/eye-line";
import { useUserStore } from "src/stores/user-store";
import { EnumWikifolioStatus } from "src/types/common-enum";
import { CBHeaderNotInvestible } from "../components/header/header-not-investible";
import { InfoBox } from "../components/info-box";
import { CBPrices } from "../components/prices";
import { CBRatioTabBar } from "../components/ratio-tab-bar";
import { SpacedContainer } from "../components/spaced-container";
import { CBCertificateFee, CBPerformanceFee } from "../components/statistics";
import { useCertificateBoxContext } from "../context";

const PUBLISH_BUTTON_TEST_ID = "publish-button";

export const CertificateBoxTest = () => {
    const userStore = useUserStore();
    const { dict, data } = useCertificateBoxContext();
    const isPublishRequested = data.wikifolio.status === EnumWikifolioStatus.PublishingRequested;

    return (
        <>
            <CBHeaderNotInvestible tooltip={data.tooltips.previewMode} />
            <SpacedContainer>
                {data.certificates.length > 1 && <CBRatioTabBar />}
                <CBPrices />
                <Divider />

                <Stack spacing={1}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                </Stack>
                <Divider />

                <InfoBox icon={<IconEyeLine sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography fontSize="sm">{dict.testMessage}</Typography>
                </InfoBox>
                {userStore.isCurrentUser(data.trader) && (
                    <Button
                        {...(isPublishRequested ? {} : { component: "a", href: data.editLink })}
                        disabled={isPublishRequested}
                        variant="contained"
                        size="medium"
                        color="green"
                        data-test-id={PUBLISH_BUTTON_TEST_ID}
                    >
                        {dict.publishButton}
                    </Button>
                )}
            </SpacedContainer>
        </>
    );
};
